import { useState, useEffect, useCallback } from "react";
import api from "../../services/api";

// Determina o estágio de configuração da conta com uma única busca,
// compartilhada entre o checklist de primeiros passos e o controle de
// exibição da mensagem de boas-vindas.
//
// `isEstablished` indica que a conta claramente NÃO é um primeiro acesso.
// É usado para não importunar usuários antigos com o onboarding mesmo que
// o localStorage seja limpo.
//
// IMPORTANTE: filas (e tags) passaram a ser criadas automaticamente na
// criação da empresa, então `hasQueue` é sempre verdadeiro para contas
// novas e NÃO pode mais ser usado como sinal de conta estabelecida — senão
// a mensagem de boas-vindas e o tour nunca apareceriam. O que caracteriza
// uma conta já em uso é uma ação genuína do usuário: conectar o WhatsApp
// ou adicionar um atendente.
const useOnboardingStatus = () => {
  const [status, setStatus] = useState({
    loading: true,
    hasQueue: false,
    hasQueueLinked: false,
    hasWhatsapp: false,
    hasUser: false,
  });

  const reload = useCallback(async () => {
    try {
      const [wpRes, qRes, uRes] = await Promise.all([
        api.get("/whatsapp/?session=0"),
        api.get("/queue"),
        api.get("/users"),
      ]);
      const connections = wpRes.data || [];
      setStatus({
        loading: false,
        hasWhatsapp: connections.some((w) => w.status === "CONNECTED"),
        // Fila vinculada = conexão conectada com ao menos 1 fila atrelada
        hasQueueLinked: connections.some(
          (w) => w.status === "CONNECTED" && w.queues && w.queues.length > 0
        ),
        hasQueue: (qRes.data || []).length > 0,
        // Mais de 1 usuário = um atendente foi adicionado além do admin
        hasUser: (uRes.data?.users ?? uRes.data ?? []).length > 1,
      });
    } catch (_) {
      setStatus((s) => ({ ...s, loading: false }));
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const isEstablished =
    !status.loading &&
    (status.hasWhatsapp || status.hasUser);

  return { ...status, isEstablished, reload };
};

export default useOnboardingStatus;
